import Footer from "../footer";
import Header from "../header";
import { Routes, Route } from "react-router-dom";
import Home from "../../views/home";
import Servicios from "../../views/servicios";
import Nosotros from "../../views/nosotros";
import Productos from "../../views/productos";
import Descargas from "../../views/descargas";
import Aplicaciones from "../../views/aplicaciones";
import Contacto from "../../views/contacto";
import Garantia from "../../views/garantia";
import CalculadoraDosificacion from "../../views/calculadoras";

function App() {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/servicios" element={<Servicios />} />
        <Route path="/nosotros" element={<Nosotros />} />
        <Route path="/productos/*" element={<Productos />} />
        <Route path="/aplicaciones/*" element={<Aplicaciones />} />
        <Route path="/descargas" element={<Descargas />} />
        <Route path="/contacto" element={<Contacto />} />
        <Route path="/calculadora" element={<CalculadoraDosificacion />} />
        <Route path="/garantia.html" element={<Garantia />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
